import {
  IDroneTelemetryRepository,
  DroneTelemetryEntity,
  ResponseValueObject,
} from '@gishub/domain';

export class DroneTelemetryRepository implements IDroneTelemetryRepository {
  async getTelemetry(): Promise<ResponseValueObject<DroneTelemetryEntity>> {
    return new ResponseValueObject(true, {
      altitude: 250_000,
      velocity: 0,
      heading: 0,
      camera: 'NADIR',
      zoom: 1.0,
      lat: -11.55,
      lon: -75.0,
      tilt: 50.0,
      datum: 'WGS84 UTM 18S JUNIN PERU',
      distance: 0,
      battery: 100,
    });
  }
}
